<template>
  <div class="product-details-content-setup">
    <div class="row">
      <aside class="view-content-aside col-lg-3 d-none d-lg-block">
        <steps :step="currentStep" :names="steps" @change-step="changeStep" />
      </aside>
      <div class="col-12 d-lg-none">
        <steps :step="currentStep" :names="steps" @change-step="changeStep" />
      </div>
      <section class="view-content-main col-lg-9">
        <setup-step-01 v-if="currentStep === 1" :form="form" :errors="errors" />
        <setup-step-02 v-if="currentStep === 2" :form="form" :errors="errors" />
        <setup-step-03 v-if="currentStep === 3" :form="form" :errors="errors" />
        <setup-step-04 v-if="currentStep === 4" :form="form" :errors="errors" />
        <setup-step-support
          v-if="currentStep === 5"
          :form="form"
          :errors="errors"
        />
        <setup-step-faq v-if="currentStep === 6" />

        <div
          class="d-flex flex-column flex-md-row justify-content-between mt-9"
        >
          <button
            class="btn btn-outline-secondary order-1 order-md-0 mt-5 mt-md-0"
            @click="back"
          >
            <span v-if="currentStep === 1">Cancelar</span>
            <span v-else class="d-flex align-items-center">
              <i class="icon-angle-left mr-3" />
              Voltar
            </span>
          </button>
          <button
            class="btn"
            :class="isValid ? 'btn-primary ' : 'btn-secondary'"
            :disabled="!isValid"
            @click="next"
          >
            <loading v-if="currentStep === steps.length" :show="loading">
              Salvar
            </loading>
            <span v-else class="d-flex align-items-center">
              Próximo
              <i class="icon-angle-right ml-3" />
            </span>
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { TRANSLATE_FIELD_MEMBER_SETUP } from "@/constants/fields.js";
import { formFields, get_error_msg } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";
import SetupStep01 from "./SetupStep01";
import SetupStep02 from "./SetupStep02";
import SetupStep03 from "./SetupStep03";
import SetupStep04 from "./SetupStep04";
import SetupStepFaq from "./SetupStepFaq";
import SetupStepSupport from "./SetupStepSupport";

export default {
  components: {
    SetupStep01,
    SetupStep02,
    SetupStep03,
    SetupStepSupport,
    SetupStepFaq,
    SetupStep04
  },
  props: {
    setup: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentStep: 1,
      loading: false,
      steps: [
        "Informações básicas",
        "Personalização",
        "Configurar certificado",
        "Personalizar certificado",
        "Suporte",
        "FAQ"
      ],
      ...formFields(
        [
          "name",
          "description",
          "subdomain",
          "domain",
          "gtm_id",
          "logo",
          "background",
          "brand",
          "header",
          "config",
          "product_id",
          "showcase",
          "link_sale_page",
          "name_course",
          "hourly_load",
          "organizer_name",
          "image_signature",
          "metadata_certification",
          "certificate_background_image",
          "certificate_enabled",
          "access_unit",
          "access_period",
          "password_default",
          "minimum_content_progress",
          "minimum_quiz_progress",
          "metadata_support",
          "social_media_enabled",
          "social_media",
          "cover_view_type",
          "cover",
          "link_video",
          "video_display",
          "cover_view_type_mobile",
          "cover_mobile",
          "link_video_mobile",
          "placeholder_cover",
          "placeholder_lesson",
          "placeholder_module",
          "placeholder_cover_mobile",
          "cover_blitz_club"
        ],
        {
          link_video_mobile: "",
          link_video: "",
          description: "",
          product_id: this.$route.params.id,
          certificate_enabled: true,
          ...this.setup,
          metadata_support: this.setup?.metadata_support || {
            description: "",
            phone: "",
            email: "",
            link_chat_whatsapp: "",
            opening_hours: ""
          },
          access_period: this.setup?.access_period || "unlimited_access",
          metadata_certification: {
            color_1: get(
              this.setup,
              "metadata_certification.color_1",
              "#2E0A5D"
            ),
            color_2: get(
              this.setup,
              "metadata_certification.color_2",
              "#AD3E9B"
            ),
            typography: get(
              this.setup,
              "metadata_certification.typography",
              "Inter"
            ),
            text_color: get(
              this.setup,
              "metadata_certification.text_color",
              "#6E6E6E"
            ),
            signature_typography: this.setup.metadata_certification
              ?.signature_typography
          },
          config: {
            style: get(this.setup, "config.style", "dark")
          },
          hourly_load: String(this.setup.hourly_load),
          social_media: this.setup.social_media || {},
          social_media_enabled: this.setup.social_media_enabled
        }
      )
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    isValid() {
      switch (this.currentStep) {
        case 1:
          return (
            this.form?.name &&
            this.form?.name.length <= 250 &&
            this.form?.description?.length <= 980 &&
            this.form?.subdomain
          );
        case 4:
          return (
            (this.form.hourly_load && this.form.name_course) ||
            !this.form.certificate_enabled
          );
        default:
          return true;
      }
    }
  },
  methods: {
    changeStep(step) {
      this.currentStep = step;
    },
    back() {
      if (this.currentStep === 1) {
        this.$router.go(-1);
      } else {
        this.currentStep--;
      }
    },
    next() {
      if (this.currentStep === this.steps.length) {
        this.submit();
      } else {
        this.currentStep++;
      }
    },
    openClub() {
      window.open(
        `https://${this.form.subdomain}.club.blitzpay.com.br`,
        "_blank"
      );
    },
    refresh() {
      this.errors = {};
      this.$store.dispatch("product/getProduct", this.$route.params.id).then();
      this.$store.dispatch("membersSetup/get", this.$route.params.id).then();
    },
    async submit() {
      if (this.loading) return;

      this.errors = {};
      //check step 1
      if (!this.form.subdomain) {
        this.errors.subdomain = ["Este campo não pode ser em branco."];
      }
      if (!this.form.name) {
        this.errors.name = ["Este campo não pode ser em branco."];
      }
      if (this.form.name?.length > 250) {
        this.errors.name = ["Este campo não deve ter mais que 250 caracteres"];
      }
      if (this.form.description && this.form.description?.length > 255) {
        this.errors.description = [
          "Este campo não deve ter mais que 255 caracteres"
        ];
      }
      if (Object.keys(this.errors).length) {
        this.currentStep = 1;
      }
      //check step 4
      if (!this.form.hourly_load && this.form.certificate_enabled) {
        this.errors.hourly_load = ["Um número inteiro válido é exigido."];
      }
      if (this.form.hourly_load === "0" && this.form.certificate_enabled) {
        this.errors.hourly_load = ["Carga horária deve ser maior que 0."];
      }
      if (!this.form.name_course && this.form.certificate_enabled) {
        this.errors.name_course = ["Este campo não pode ser em branco."];
      }
      if (!this.form.organizer_name && this.form.certificate_enabled) {
        this.errors.organizer_name = ["Este campo não pode ser em branco."];
      }
      if (Object.keys(this.errors).length) {
        if (
          !(
            this.errors.name ||
            this.errors.subdomain ||
            this.errors.description
          )
        ) {
          this.currentStep = 4;
          if (this.errors.organizer_name) {
            this.$message.error(
              `Campo "Nome do organizador", na aba "Assinatura", não pode ser em branco.`
            );
          }
        }
        return;
      }

      const data = { ...this.form };
      let action = "membersSetup/post";

      if (this.setup.id) {
        data.id = this.setup.id;
        action = "membersSetup/put";
      }
      if (!this.form.domain || this.form.domain === "") {
        data.domain = null;
      }
      if (!(this.form.hourly_load && this.form.certificate_enabled)) {
        data.hourly_load = null;
      }
      if (!(this.form.name_course && this.form.certificate_enabled)) {
        data.name_course = null;
      }
      if (!this.form.password_default) {
        data.password_default = null;
      }
      if (this.form.organizer_name === "" && !this.form.certificate_enabled) {
        data.organizer_name = null;
      }

      this.loading = true;

      try {
        await this.saveFAQS();
        await this.$store.dispatch(action, data);
        this.$message.success("Salvo com sucesso");
        this.refresh();
      } catch (error) {
        if (error?.response?.data) {
          if (
            ["subdomain", "name", "description", "domain"].find(key =>
              error.response.data.hasOwnProperty(key)
            )
          ) {
            this.currentStep = 1;
          }
          if (
            ["name_course", "hourly_load"].find(key =>
              error.response.data.hasOwnProperty(key)
            )
          ) {
            this.currentStep = 4;
          }
          this.errors = error.response.data;
        }

        let msg = get_error_msg(
          error?.response?.data,
          TRANSLATE_FIELD_MEMBER_SETUP,
          `Erro ao configuração de área de membros`
        );
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    },
    async saveFAQS() {
      for (let k in this.$store.state.membersSetup.faqs) {
        let action = "membersSetup/postFAQ";
        let item = {
          product_id: this.$route.params.id,
          ...this.$store.state.membersSetup.faqs[k],
          sort: this.$store.state.membersSetup.faqs[k].sort || k
        };

        if (item.id) {
          action = "membersSetup/putFAQ";
          delete item.company_id;
        }

        if (!item.question.length) {
          this.$message.warning(
            `FAQ: Digite o título da pergunta ${Number(k) + 1}.`
          );
          this.currentStep = 6;
          throw new Error();
        }

        if (!item.answer.length) {
          this.$message.warning(
            `FAQ: Digite a resposta da pergunta ${Number(k) + 1}.`
          );
          this.currentStep = 6;
          throw new Error();
        }

        await this.$store.dispatch(action, item);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details-content-setup {
  .view-content-aside {
    padding: 24px 16px 48px 15px;
    border-right: 1px solid #e1dfe6;
  }
  .view-content-main {
    position: relative;
    padding: 24px 15px 48px 24px;
  }
  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
